import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-password-policy-popover',
  templateUrl: './password-policy-popover.component.html',
  styleUrls: ['./password-policy-popover.component.scss'],
})
export class PasswordPolicyPopoverComponent {
  @Input() password = '';
  @Input() placement: 'top' | 'bottom' = 'bottom';

  isOpen = false;
}
